import { ActivityLevel, GeoTag } from '@lciapps/lci-core';
import { ActivityParticipant, ParticipantStatus } from './activity-participant.model';
import { ActivityStatus } from './activity-status.enum';
/*tslint:disable*/
export class Activity {
  public activityId: number = 0;
  public activityName: string = '';
  public activityTypeId: number = null;
  public activityCauseId: number = null;
  public activityCauseName: string = '';
  public activityStatus: ActivityStatus = null;
  public location: string = '';
  public startDate: Date | any = null;
  public endDate: Date | any = null;
  public description: string = '';
  public visibilityType: string = 'Everyone';
  public inviteType: string = 'Everyone';
  public activitySource: string = '';
  public photoUrl: string = '';
  public participantsNeeded: number = 0;
  public whoBenefits: string = '';
  public donationGoal: number = 0;
  public currencyId: number = 0;
  public lcifGranted: boolean = false;
  public ownerId: string = '';
  public organizerPhotoUrl: string = '';
  public organizerName: string = '';
  public organizerLocalName: string = '';
  public organizerLocalClubName: string = '';
  public organizerCity: string = '';
  public organizerClub: string = '';
  public organizerMembershipType: string = '';
  public inviteeCount: number = 0;
  public participantCount: number = 0;
  public followerCount: number = 0;
  public averageRating: number = 0;
  public ratingCount: number = 0;
  public geoTag: GeoTag = new GeoTag();
  public activityInvites: Array<ActivityInvite | any> = [];
  public activityLevels: ActivityLevel[] = [];
  public activityUrl: string = '';
  public placeName: string = '';
  public latitude: number = 0;
  public longitude: number = 0;
  public activityCompanyName: string = '';
  public companyId: number = 0;
  public activityCompanyId: number = 0;
  public activityDistrictName: string = '';
  public activityMultiDistrictName: string = '';
  public activityDistrictId: number = 0;
  public activityMultiDistrictId: number = 0;
  public communityOutcome: string = '';
  public blueprintId: number = null;
  public isDraft?: boolean = true;
  public signatureName: string = '';
  public signatureId: number = 0;
  public donationOrganization: string = '';
  public organizationName: string = '';
  public signatureFlag?: boolean = false;
  public isAdditionalMetrics: boolean = false;
  public activityTimeZoneId: string = '';
  public activityStartDate: Date | any = null;
  public activityEndDate: Date | any = null;
  public isDonationToLCIF?: boolean = false;
  public activityTimeZoneAbbrevation?: string = '';
  public isNonLionFamilyMembersParticipated: string = null;
  public isUpdateInviteRequired?:boolean = false;
  constructor(defaults?: any) {
    if (defaults) {
      for (const key in defaults) {
        if (this.hasOwnProperty(key)) {
          this[key] = defaults[key];
        }
        if (defaults.lcifGrant) {
          this.lcifGranted = defaults.lcifGrant;
        }
      }
    }
  }

  public getPostObject(): ActivityPost {
    return new ActivityPost(this);
  }

  public getPutObject(): ActivityPut {
    return new ActivityPut(this);
  }
}

export class ActivityPost {
  public activityName: string = '';
  public activityTypeId: number = null;
  public activityCauseId: number = null;
  public location: string = '';
  public startDate: Date | any = null;
  public endDate: Date | any = null;
  public description: string = '';
  public visibilityType: string = 'Everyone';
  public inviteType: string = 'Everyone';
  public activitySource: string = 'User';
  public lcifGranted: boolean = false;
  public invitees: Invitee[] = [];
  public activityUrl: string = '';
  public placeName: string = '';
  public latitude: number = 0;
  public longitude: number = 0;
  public isDraft: boolean = true;
  public communityOutcome: string = '';
  public blueprintId: number = null;
  public donationGoal: number = 0;
  public companyId: number = 0;
  public signatureId: number = 0;
  public donationOrganization: string = '';
  public photoUrl: string = '';
  public signatureFlag?: boolean = false;
  public isAdditionalMetrics: boolean = false;
  public activityTimeZoneId: string = '';
  public activityStartDate: Date | any = null;
  public activityEndDate: Date | any = null;
  public isDonationToLCIF?: boolean = false;
  public isNonLionFamilyMembersParticipated: string = null;
  constructor(defaults?: any) {
    if (defaults) {
      for (const key in defaults) {
        if (this.hasOwnProperty(key)) {
          this[key] = defaults[key];
        }
      }
      if (defaults.activiteeInvites) {
        this.invitees = defaults.activityInvites;
      }
    }
  }
}

export class ActivityPut {
  public activityName: string = '';
  public activityTypeId: number = 0;
  public activityCauseId: number = 0;
  public location: string = '';
  public startDate: Date | any = null;
  public endDate: Date | any = null;
  public description: string = '';
  public lcifGranted: boolean = false;
  public visibilityType: string = 'Everyone';
  public inviteType: string = 'Everyone';
  public activitySource: string = 'User';
  public activityUrl: string = '';
  public placeName: string = '';
  public latitude: number = 0;
  public longitude: number = 0;
  public communityOutcome: string = '';
  public blueprintId: number = 0;
  public donationGoal: number = 0;
  public companyId: number = 0;
  public signatureId: number = 0;
  public donationOrganization: string = '';
  public signatureFlag?: boolean = false;
  public isAdditionalMetrics: boolean = false;
  public activityTimeZoneId: string = '';
  public activityStartDate: Date | any = null;
  public activityEndDate: Date | any = null;
  public isDonationToLCIF?: boolean = false;
  public lcifGrant?: boolean = false;
  public isNonLionFamilyMembersParticipated: string = null;
  constructor(defaults?: any) {
    if (defaults) {
      if (defaults.lcifGrant) {
        this.lcifGranted = defaults.lcifGrant;
      }
      for (const key in defaults) {
        if (this.hasOwnProperty(key)) {
          this[key] = defaults[key];
        }
      }
    }
  }
}

export class Invitee {
  public userId: string = '';
  public memberId: number = 0;
  public inviteeType: string = 'Member';
  public inviteeRole: string = 'Organizer';
}

export class ActivityInvite {
  public inviteId: number = 0;
  public activityId: number = 0;
  public userId: string = '';
  public memberId: number = 0;
  public inviteStatus: string = '';
  public inviteMode: string = '';
  public invitedOn: Date | any = null;
  public respondedOn: Date | any = null;
  public inviteeType: string = 'Member';
  public inviteeRole: string = 'Organizer';
  public fullName: string = '';
  public inviteeLocation: string = '';
  public photoUrl: string = '';
  public membershipType: string = '';
  public localCompanyName: string = '';
  public localPersonName: string = '';
  public localName: string = '';

  constructor(defaults?: any) {
    if (defaults) {
      if (defaults instanceof ActivityParticipant) {
        this.loadParticipant(defaults);
      }
      Object.keys(defaults).forEach(key => {
        if (this.hasOwnProperty(key)) {
          this[key] = defaults[key];
        }
      });
    }
  }

  /**
   * Loads the correct invite status based on an activity participant status
   * @param {ActivityParticipant} defaults
   */
  private loadParticipant(defaults: ActivityParticipant): void {
    if (
      defaults.participantStatus === ParticipantStatus.Attended ||
      defaults.participantStatus === ParticipantStatus.Participating
    ) {
      this.inviteStatus = InviteStatus.Accepted;
    } else if (defaults.participantStatus === ParticipantStatus.NotAttended) {
      this.inviteStatus = InviteStatus.Denied;
    }
    this.photoUrl = defaults.profileImageUrl;
  }
}

export enum InviteStatus {
  Invited = 'Invited',
  Accepted = 'Accepted',
  Denied = 'Denied',
  Maybe = 'Maybe'
}

export enum InviteMode {
  Mobile = 'Mobile',
  Web = 'Web'
}
